import { useCallback } from 'react';
import { CuboidBase, CuboidStyleHandlers } from '../types';
import { CuboidStyle } from '@fabric-web/3d-viewer';

export const useMakeStyledCuboid = <CuboidT extends CuboidBase>({
  makeCuboidStyles,
}: CuboidStyleHandlers<CuboidT>) => {
  const makeStyledCuboid = useCallback(
    (cuboid: CuboidT, options?: Partial<CuboidStyle>) => {
      const styles = makeCuboidStyles(cuboid, options);
      const { id, name, position, rotation, scale } = cuboid;
      return {
        id,
        name: name ?? id,
        position,
        rotation,
        scale,
        ...styles,
        cuboidData: cuboid,
      };
    },
    [makeCuboidStyles]
  );

  return makeStyledCuboid;
};
